import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
  /** "full" = layout skeleton (for auth loading), "content" = inline spinner (for Suspense inside layout) */
  variant?: 'full' | 'content';
}

export default function LoadingScreen({ message = 'Cargando...', variant = 'full' }: LoadingScreenProps) {
  if (variant === 'content') {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <Loader2 className="w-8 h-8 text-primary-600 animate-spin" />
        <p className="text-gray-500 text-sm mt-3">{message}</p>
      </div>
    );
  }

  // Full layout skeleton — matches MainLayout dimensions to prevent CLS
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar placeholder (hidden on mobile, w-64 on desktop) */}
      <div className="hidden lg:block w-64 shrink-0 bg-white border-r border-gray-200" />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Navbar placeholder */}
        <div className="h-16 bg-white border-b border-gray-200 shrink-0" />

        {/* Content area with spinner */}
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 bg-primary-600 rounded-xl flex items-center justify-center shadow-lg">
              <span className="text-2xl font-bold text-white">AZ</span>
            </div>
            <Loader2 className="w-8 h-8 text-primary-600 animate-spin" />
            <p className="text-gray-500 text-sm">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
